export default function(http) {
  return {
      //获取
      getServer(data){
          return http.json({
              url: '/operationLog/server/get',
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/server.js